<!--
 * @Descripttion: logisticsOrderList--物流订单表
 * @version: 1
 * @Author: lk
 * @Date: 2019-08-19 17:14:03
 * @LastEditors: lzq
 * @LastEditTime: 2024-01-02 17:13:52
 -->
<template>
  <div v-loading.fullscreen="loading" element-loading-text="加载中">
    <el-card>
      <condition-search :query-items="queryItems" :search-param="searchParam" @search="search" @reset="reset" />
    </el-card>
    <el-card>
      <el-button v-if="$btnsPermission('custom:add')" type="primary" @click="handleAdd">新增客户</el-button>
      <el-table style="margin-top: 12px;" ref="dataTable" :height="heightStyleObj" :data="pageListData" highlight-current-row border>
        <el-table-column prop="" width="60" label="序号" show-overflow-tooltip>
          <template slot-scope="{ $index }">
            {{ $index + 1 + (searchParam.pageNum - 1) * searchParam.pageSize }}
          </template>
        </el-table-column>
        <el-table-column show-overflow-tooltip prop="customer" min-width="120px" label="客户名称" />
        <el-table-column show-overflow-tooltip prop="customerName" min-width="120px" label="客户联系人">
        </el-table-column>
        <el-table-column show-overflow-tooltip prop="customerAddress" min-width="120px" label="客户地址">
        </el-table-column>
        <el-table-column show-overflow-tooltip prop="createBy" width="140px" label="创建人">
        </el-table-column>
        <el-table-column show-overflow-tooltip prop="createTime" width="180px" label="创建时间">
          <template slot-scope="scope">
            {{ scope.row.createTime ? parseTime(scope.row.createTime) : null }}
          </template>
        </el-table-column>
        <el-table-column show-overflow-tooltip prop="warehouseType" min-width="120px" label="收件人姓名">
          <template slot-scope="{ row }">
            {{ row.customerRecipientVoList ? row.customerRecipientVoList.map(item => item.name).join('、') : null }}
          </template>
        </el-table-column>
        <el-table-column label="操作" fixed="right" width="180" align="center">
          <template slot-scope="{ row }">
            <el-button type="text" @click="handlePreview(row)">查看</el-button>
            <el-button v-if="$btnsPermission('custom:edit')" type="text" @click="handleEdit(row)">
              编辑
            </el-button>
            <el-button v-if="$btnsPermission('custom:del')" type="text" @click="hanldDelete(row)">删除</el-button>
          </template>
        </el-table-column>
      </el-table>
      <pagination v-show="searchParam.total > 0" :total="searchParam.total" :page.sync="searchParam.pageNum"
        :limit.sync="searchParam.pageSize" @pagination="getPageListData" />
    </el-card>
    <detialCustom v-if="previewShow" :visible="previewShow" :custom-info="customInfo" @close="close">
    </detialCustom>
    <addOrEdit v-if="addShow" :visible="addShow" :custom-info="customInfo" @close="close"></addOrEdit>
  </div>
</template>

<script>
import { getDict } from '@/api/common'
import { getCustomList, deleteCustom } from '@/api/system/custom'
import detialCustom from './components/detialCustom'
import addOrEdit from './components/addOrEdit'
export default {
  name: 'Custom',
  components: {
    addOrEdit,
    detialCustom,
  },
  data() {
    return {
      heightStyleObj: '',
      loading: true, // 遮罩
      previewShow: false, // 详情
      addShow: false,
      pageListData: [], // 列表数据
      customInfo: {},
      queryItems: [
        {
          label: '关键字',
          field: 'searchKey',
          placeholder: '客户名称',
          width: '300px',
          type: 'input'
        },
        {
          label: '单据编号',
          field: 'dateTime',
          type: 'input'
        },
      ],
      searchParam: { // 查询参数
        pageNum: 1,
        pageSize: 10,
        total: 0,
      },
    }
  },


  created() {
    this.heightStyleObj = window.innerHeight - 405 + 'px'
    this.getPageListData()
    if (this.$route.query.add) {
      this.handleAdd()
    }
  },
  methods: {
    handlePreview(row) {
      this.previewShow = true
      this.customInfo = JSON.parse(JSON.stringify(row))
    },
    handleAdd() {
      this.customInfo = {}
      this.addShow = true
    },
    handleEdit(row) {
      this.addShow = true
      this.customInfo = JSON.parse(JSON.stringify(row))
    },
    close() {
      this.addShow = false
      this.previewShow = false
      this.getPageListData()
    },

    //删除仓库
    hanldDelete({ id }) {
      this.$confirm('您确定要删除当前客户？', '删除', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.loading = true // 打开遮罩
        deleteCustom({ ids: id }).then(() => {
          this.$message.success('删除成功')
          this.getPageListData() // 重新加载数据列表
        }).finally(() => {
          this.loading = false // 关闭遮罩
        })
      })

    },

    // 获取字典
    getDicts(list) {
      list.forEach(dictType => {
        getDict({ dictType }).then((res) => {
          this.dictObj[dictType] = res.rows
          if (dictType === 'orderStatus' || dictType === 'warehouseType') {
            const findIndex = this.queryItems.findIndex(item => item.field === dictType)
            this.queryItems[findIndex].options = JSON.parse(JSON.stringify(res.rows))
          }
        })
      })
    },


    // 查询
    search() {
      this.searchParam.pageNum = 1
      this.getPageListData()
    },
    // 重置查询
    reset() {
      this.searchParam = Object.assign(this.$data.searchParam, this.$options.data.call(this)).searchParam
      this.getPageListData()
    },

    // 获取列表数据
    getPageListData() {
      this.loading = true
      const searchParam = JSON.parse(JSON.stringify(this.searchParam))
      if (searchParam.dateTime) {
        const [startTime, endTime] = searchParam.dateTime
        searchParam.startTime = startTime
        searchParam.endTime = endTime
        delete searchParam.dateTime
      }
      getCustomList(searchParam).then(res => {
        this.searchParam.total = res.total
        this.pageListData = res.rows
      }).finally(() => {
        this.loading = false
      })
    },
  }
}
</script>
